import { render, staticRenderFns } from "./iconFont.vue?vue&type=template&id=4957bcfd&scoped=true"
import script from "./iconFont.vue?vue&type=script&lang=js"
export * from "./iconFont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4957bcfd",
  null
  
)

export default component.exports